// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"757":"dc111814","4902":"a5003a61","5338":"7f79fa6f","8305":"7e0130ef","9741":"7f79fa6f"}[chunkId] + ".chunk.css";
};